export class Greater {
    constructor(field, value) {
        this.field = field;
        this.value = value;
    }
    buildPartFilter() {
        return `${this.field}=gt:${this.value}`;
    }
}
